import {IconProps} from './types';

const Pencil = ({fill = 'currentColor', className, width = 24, height = 24}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 24 24"
        className={className}
    >
        <path
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19 10.5H22.5C22.7652 10.5 23.0196 10.6054 23.2071 10.7929C23.3946 10.9804 23.5 11.2348 23.5 11.5V18.5C23.5 18.7652 23.3946 19.0196 23.2071 19.2071C23.0196 19.3946 22.7652 19.5 22.5 19.5H1.5C1.23478 19.5 0.98043 19.3946 0.792893 19.2071C0.605357 19.0196 0.5 18.7652 0.5 18.5V11.5C0.5 11.2348 0.605357 10.9804 0.792893 10.7929C0.98043 10.6054 1.23478 10.5 1.5 10.5H7"
        />
        <path
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13.1609 12.8799L8.21191 14.9989L10.3329 10.0499L19.1719 1.21094L21.9999 4.03894L13.1609 12.8799Z"
        />
        <path
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M20.1639 5.87485L17.3359 3.04785"
        />
        <path
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13.161 12.8798L10.333 10.0498"
        />
    </svg>
);

export default Pencil;
